module.exports = __webpack_public_path__ + "img/fundas-01.88f3bcf5.png";